export const EXPERIMENTS = {
  SUBMISSION_TRACK_EVENT: 'specs.form-app.SubmissionTrackEventEnabled',
  AI_ASSISTANT: 'specs.form-app.AiFormAssistant',
  AI_ASSISTANT_TYPING_EFFECT: 'specs.form-app.AiFormAssistantTypingEffect',
  ENABLE_MULTILINE_ADDRESS: 'specs.forms.MultilineAddressInTemplates',
};
